import { Box, CircularProgress } from "@mui/material";
import DebouncedTextField from "@/components/DebouncedTextField";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import SectionAccordion from "./SectionAccordion";
import MedicationEntryList from "./MedicationEntryList";
import PharmacyEntryList from "./PharmacyEntryList";
import { useMedicationSection } from "../hooks/use-medication-section";
import {
  FREE_TEXT_LABEL,
  FREE_TEXT_MAX_ROWS,
  FREE_TEXT_PLACEHOLDER,
  PHARMACY_LABELS,
} from "../readmission-f2f-constant";
import { MEDICATION_LABELS } from "../readmission-f2f-medication-constant";
import { ReadmissionSectionProps } from "../readmission-f2f-types";

const MedicationSection = ({
  title,
  expanded,
  onToggle,
  payload,
  update,
}: ReadmissionSectionProps) => {
  const medications = useMedicationSection(expanded);

  return (
    <SectionAccordion
      title={title}
      expanded={expanded}
      onToggle={onToggle}
      showCurrentVisit={false}
    >
      <Flex gap={2} flexWrap="wrap" alignItems="flex-start">
        <Box
          flex={1}
          minWidth={320}
          display="flex"
          flexDirection="column"
          gap={1}
        >
          <Text fontWeight="bold" c="text.secondary" size={12}>
            {MEDICATION_LABELS.section}
          </Text>
          {medications.isLoading ? (
            <Flex justifyContent="center" p={2}>
              <CircularProgress size={22} />
            </Flex>
          ) : (
            <MedicationEntryList
              medications={medications}
              isEnabled={expanded}
            />
          )}
        </Box>
        <Box
          flex={1}
          minWidth={320}
          display="flex"
          flexDirection="column"
          gap={1}
        >
          <Text fontWeight="bold" c="text.secondary" size={12}>
            {PHARMACY_LABELS.section}
          </Text>
          <PharmacyEntryList
            items={payload.pharmacies}
            isEnabled={expanded}
            onChange={(pharmacies) => update({ pharmacies })}
          />
        </Box>
      </Flex>
      <Text fontWeight="bold">{FREE_TEXT_LABEL}</Text>
      <DebouncedTextField
        size="small"
        fullWidth
        multiline
        minRows={3}
        maxRows={FREE_TEXT_MAX_ROWS}
        placeholder={FREE_TEXT_PLACEHOLDER}
        value={payload.medicationFreeText}
        onChange={(medicationFreeText) => update({ medicationFreeText })}
      />
    </SectionAccordion>
  );
};

export default MedicationSection;
